export default __webpack_public_path__ + "static/04-ca5ac78617f7bd4b6b7da2be3b7bb24e.jpg";